import type { ReactNode } from "react";
import { ClipboardList } from "lucide-react";

export type EmptyProps = {
  title?: string;
  icon?: ReactNode;
  children?: ReactNode;
  action?: { label: string; onClick: () => void };
};

export function Empty({ title = "Nenhum registro encontrado", icon, children, action }: EmptyProps) {
  return (
    <div className="empty">
      <span aria-hidden="true">{icon ?? <ClipboardList size={32} />}</span>
      <h3>{title}</h3>
      <p>{children || "Os novos registros aparecerão aqui."}</p>
      {action && (
        <button type="button" className="secondary" onClick={action.onClick}>
          {action.label}
        </button>
      )}
    </div>
  );
}
